export var Background = {
  Primary: 'primary',
  Secondary: 'secondary'
};